import { motion } from "framer-motion";
import { Icon } from "./base/Icon";
import { Text, Button } from "./base";
import clsx from "clsx";

interface EmptyMessageProps {
  className?: string;
  title?: string;
  description?: string;
  iconName?: string;
  buttonText?: string | null;
  onClickAdd?: (data?: any) => void;
  actionData?: any;
}

export const EmptyMessage = ({
  className,
  title = "Not Found",
  description = "Add your first to get started.",
  iconName = "list",
  buttonText = "Add",
  onClickAdd = () => {},
}: EmptyMessageProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.5 }}
      className={clsx(
        "flex flex-col items-center justify-center py-20 px-4 bg-gray-50 dark:bg-gray-800/30 rounded-xl border-2 border-dashed border-gray-200 dark:border-gray-700",
        className,
      )}
    >
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.5 }}
        className="w-24 h-24 mb-6 flex items-center justify-center rounded-full bg-brand/10 dark:bg-brand/20"
      >
        <Icon
          name={iconName}
          size={48}
          className="text-brand dark:text-brand-light"
        />
      </motion.div>
      <Text className="text-2xl font-medium text-gray-700 dark:text-gray-300 mb-2">{title}</Text>
      {description.split("\n").map((line, index) => (
        <Text
          key={index}
          className="text-gray-500 dark:text-gray-400 text-center max-w-md"
        >
          {line}
        </Text>
      ))}
      {buttonText && buttonText.trim() && (
        <Button
          className="mt-8"
          onClick={onClickAdd}
          variant="brand"
        >
          <Icon
            name="add"
            size={18}
          />
          {buttonText}
        </Button>
      )}
    </motion.div>
  );
};
